import { render } from "./OrderDataForUpload.vue?vue&type=template&id=e8dfc3a4"
import script from "./OrderDataForUpload.vue?vue&type=script&lang=js"
export * from "./OrderDataForUpload.vue?vue&type=script&lang=js"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal_claud/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__